import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';

// NOTA: PropuestaPage (Acanto 1) intencionalmente NO se importa ni se registra
// como ruta. El archivo src/pages/PropuestaPage.js se conserva pero es
// inaccesible desde la aplicación. Cualquier intento de navegar a /propuesta7
// (u otra ruta desconocida) redirige a "/".

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
